import { useLingui } from '@lingui/react/macro';

import { InputSearchSelect } from '@/design_system/InputSearchSelect/InputSearchSelect';
import { useBrands } from '@/models/brand';

export const BrandSearchSelect = ({
  brands,
  onChange,
}: {
  brands: { id: string; name: string }[];
  onChange: (brands: { id: string; name: string }[]) => void;
}) => {
  const { t } = useLingui();

  const { data: { brands: allBrands } = { brands: [] }, isLoading } = useBrands({
    limit: 500,
    offset: 0,
  });

  return (
    <InputSearchSelect
      isMulti
      size="small"
      isLoading={isLoading}
      label={t({
        id: 'settings.organization.data-catalogs.condition-forms.detail.question.brands.label',
        message: 'Brands',
      })}
      placeholder={t({
        id: 'settings.organization.data-catalogs.condition-forms.detail.question.brands.placeholder',
        message: 'Select brands',
      })}
      value={brands}
      options={allBrands}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
      onChange={(options) => onChange([...options])}
      onRemoveValue={(id) => {
        onChange(brands.filter((brand) => brand.id !== id));
      }}
    />
  );
};
